<template>

    <m-edit1/>

    <m-factor-2 v-bind='{...{},...{}}' :style='""' class="bg-white" ></m-factor-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mFactor2 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor2';

export default {
    name: 'HomeView',
    components: {mEdit1, mFactor2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
